module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-8.83272fb4.png";